import { Button, ContentIsland, GraphicsCheckImage, Grid, Typography } from '@razz-team/ui-web';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function UpdatedView({ text }: { text: ReactNode }) {
  const { t } = useTranslation();

  return (
    <Grid flexDirection="column" gap={4} size={12}>
      <ContentIsland>
        <Grid container alignItems="center" spacing={2}>
          <Grid size={6}>
            <GraphicsCheckImage width="100%" />
          </Grid>
          <Grid size={6}>
            <Typography variant="h5" fontWeight={500}>
              {text}
            </Typography>
          </Grid>
        </Grid>
      </ContentIsland>
      <Button href="/account/home">{t('Go home')}</Button>
    </Grid>
  );
}
